import { render, staticRenderFns } from "./WriteOffInfo.vue?vue&type=template&id=68254cab&scoped=true&"
import script from "./WriteOffInfo.vue?vue&type=script&lang=js&"
export * from "./WriteOffInfo.vue?vue&type=script&lang=js&"
import style0 from "./WriteOffInfo.vue?vue&type=style&index=0&id=68254cab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68254cab",
  null
  
)

export default component.exports